import { render, staticRenderFns } from "./campaigns-input-recipient.vue?vue&type=template&id=3b1e3c4b&"
import script from "./campaigns-input-recipient.vue?vue&type=script&lang=js&"
export * from "./campaigns-input-recipient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports